import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {GenderEnum} from '../../models/user';

@Component({
  selector: 'app-icc-imc-relation-table',
  templateUrl: './icc-imc-relation-table.component.html',
  styleUrls: ['./icc-imc-relation-table.component.scss']
})
export class IccImcRelationTableComponent implements OnInit, AfterViewInit {
  @Input() metadata: any;
  genderEnum = GenderEnum;
  headerActive: number;
  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    // Mark header indicator
    if (!this.metadata || !this.metadata.gender || this.metadata.waistHipIndexLow === undefined) return;
    if (this.metadata.waistHipIndexLow === 0) {
      this.headerActive = 0;
    } else if ((this.metadata.gender === GenderEnum.MALE && this.metadata.waistHipIndexLow === 0.85) ||
      (this.metadata.gender === GenderEnum.FEMALE && this.metadata.waistHipIndexLow === 0.70)) {
      this.headerActive = 1;
    } else if ((this.metadata.gender === GenderEnum.MALE && this.metadata.waistHipIndexLow === 1) ||
      (this.metadata.gender === GenderEnum.FEMALE && this.metadata.waistHipIndexLow === 0.85)) {
      this.headerActive = 2;
    }
  }
}
